import React, { useCallback, useState } from 'react'
import { useApp } from '../../../context/AppProvider'
import { filterBlockByType } from '../../../services/common'
import InputRadio from '../what-is-your-situation/InputRadio'

const Question = ({ block }) => {
    const blockTitle = filterBlockByType(block?.childrens, 'Titre')
    const blockrest = block?.childrens?.filter((child) => child?.block !== 'Titre')
    const { setSelectedValue, checked, setChecked, constructAffectTrueValue } = useApp()
    const [isInputSelected, setIsInputSelected] = useState(null)

    const renderChoice = useCallback(
        (child) => {
            const label = filterBlockByType(child?.childrens, 'Titre')
            const blockIntitulesiselectionne = filterBlockByType(
                child?.childrens,
                'IntituleSiSelectionne'
            )
            const intituleSiSelectionne = filterBlockByType(
                blockIntitulesiselectionne?.childrens,
                'Paragraphe'
            ).content

            const attributes = child?.attributes
            const affectTrue = constructAffectTrueValue(child)
            const affectFalse = attributes?.si_selectionne?.affecteFaux

            return {
                id: child.ID,
                label: label?.content,
                intituleSiSelectionne,
                affectTrue,
                affectFalse,
            }
        },
        [constructAffectTrueValue]
    )

    const onChange = useCallback(
        (e) => {
            const { affectTrue, affectFalse, intituleSiSelectionne } = JSON.parse(e.target.value)

            setSelectedValue((prev) => {
                const filtered = prev.filter((item) => item.affectTrue !== affectFalse)
                return [...filtered, { affectTrue, affectFalse, intituleSiSelectionne }]
            })

            setChecked((prev) => {
                const filtered = prev.filter((item) => item !== affectFalse)
                return [...filtered, affectTrue]
            })

            setIsInputSelected(affectTrue)
        },
        [setSelectedValue, setChecked]
    )

    const handleClearSelection = useCallback(
        (e) => {
            e.preventDefault()
            setChecked((prev) => prev.filter((input) => input !== isInputSelected))
            setSelectedValue((prev) => prev.filter((input) => input.affectTrue !== isInputSelected))
            setIsInputSelected(false)
        },
        [isInputSelected, setChecked, setSelectedValue]
    )

    return (
        <div className="question-block">
            <h4>{blockTitle?.content}</h4>

            <div className="what-is-your-situation-choice-container">
                {blockrest?.map((child, index) => {
                    const choice = renderChoice(child)
                    return (
                        <InputRadio
                            key={choice?.id}
                            type="quiz"
                            title={blockTitle?.content}
                            value={child}
                            onChange={onChange}
                            choice={choice}
                        />
                    )
                })}
            </div>
            {isInputSelected && (
                <button onClick={handleClearSelection} className="clear-selection-btn">
                    Effacer la selection
                </button>
            )}
        </div>
    )
}

export default Question
